import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  NgZone,
  OnDestroy,
  TemplateRef
} from '@angular/core';
import { UsersService } from '@shared/api';
import { InvestorVerificationComponent } from '../modals/investor-verification/investor-verification.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MapsAPILoader } from '@agm/core';
import { GOOGLE_ADDRESS_COMPONENT_EQUIVALENT } from '@shared/constants/google-place.ts';
import { Router } from '@angular/router';
import {
  CurrentUserService,
  HeaderAvatarService,
  ProfileService,
  SessionService,
  SessionStorageService,
  AuthService
} from '@shared/services';
import { VERIFICATION_STATUS } from '@shared/constants/verification-status';
import { Title } from '@angular/platform-browser';
import { PHOTO_TYPES } from '@shared/constants/investors';
import { MessageService } from '@pages/components/message/message.service';
import {
  ConfirmationProps,
  ConfirmationComponent
} from '../modals/confirmation';
import { AccreditedInvestorsComponent } from '../modals/accredited-investors/accredited-investors.component';
import { PasswordValidation } from '@shared/utilities/password-validation';
import { EMAIL } from '@shared/constants/email';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent implements OnInit, OnDestroy {
  @ViewChild('search')
  searchElementRef: ElementRef;
  @ViewChild('emailWarning')
  emailWarning: ElementRef;

  ngForm: FormGroup;
  securityForm: FormGroup;
  emailForm: FormGroup;
  oldEmail;
  files;
  status: boolean = false;
  username: string;
  info;
  investorInitial: string = '';
  investorPhoto;
  tempPhoto;
  isInvestorHasPhoto: boolean = false;

  fieldFilleds;
  zipIsEmpty: boolean = false;
  investorNotVerify: string = 'None';
  isAllowAccredited: boolean = false;
  isLoading: boolean = true;
  myTimeOut;

  emailExist: boolean = false;
  isEmailChange: boolean = false;
  isValidCurrentPassword: boolean = true;
  emailTimeout;
  isEmailSubmit: boolean = false;

  modalRef: BsModalRef;

  constructor(
    private title: Title,
    private fb: FormBuilder,
    private modalService: BsModalService,
    private router: Router,
    private ngZone: NgZone,
    private mapsAPILoader: MapsAPILoader,
    private _usersApi: UsersService,
    private _currentUser: CurrentUserService,
    private _notification: MessageService,
    private _headerService: HeaderAvatarService,
    private _profile: ProfileService,
    private _session: SessionService,
    private _sessionStorage: SessionStorageService,
    private _auth: AuthService
  ) {
    this.ngForm = fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: [{ value: '', disabled: true }, [Validators.required]],
      mobilePhone: ['', [Validators.required]],
      addressLine1: ['', [Validators.required]],
      addressLine2: [''],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      zip: ['', [Validators.required]],
      isAccredited: [false, [Validators.required]]
    });

    this.securityForm = fb.group(
      {
        currentPassword: ['', [Validators.required, Validators.minLength(8)]],
        password: ['', [Validators.required, Validators.minLength(8)]],
        confirm: ['', [Validators.required]]
      },
      {
        validator: PasswordValidation.MatchPassword
      }
    );

    this.emailForm = fb.group({
      email: ['', [Validators.required, Validators.pattern(EMAIL.EMAIL_REGEX)]]
    });
  }

  ngOnInit() {
    this.title.setTitle(`Partbnb - My Profile`);
    if (!JSON.parse(localStorage.getItem('currentUser'))) {
      this.router.navigate(['/app']);
      return;
    }
    const currentUser = this._currentUser.getUserInfo();
    this.investorNotVerify = currentUser.verificationStatus;
    this.oldEmail = currentUser.email;
    const { username } = JSON.parse(localStorage.getItem('currentUser'));
    this.username = username;
    this.getInitial();
    this.getPhoto(this.username);
    this.getInfo(this.username);
    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        {
          types: ['address'],
          componentRestrictions: { country: 'us' }
        }
      );
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          this.fillAddressForm(place);
        });
      });
    });
  }

  ngOnDestroy() {
    clearInterval(this.myTimeOut);
  }

  getPhoto(username) {
    if (username) {
      this._usersApi.getInvestorPhoto(username).subscribe(
        res => {
          this.investorPhoto = res;
          this.isInvestorHasPhoto = !!res;
          this.isLoading = false;
        },
        () => {
          this.isInvestorHasPhoto = false;
          this.isLoading = false;
        }
      );
    }
  }

  isNotVerify() {
    return this.investorNotVerify === VERIFICATION_STATUS.NONE;
  }

  isPending() {
    return this.investorNotVerify === VERIFICATION_STATUS.PENDING;
  }

  isVerified() {
    return this.investorNotVerify === VERIFICATION_STATUS.APPROVED;
  }

  getInfo(username) {
    if (username) {
      this._usersApi.getInvestorInfo(username).subscribe(res => {
        if (res) {
          this.info = res;
          this.ngForm.controls.firstName.setValue(res.firstName);
          this.ngForm.controls.lastName.setValue(res.lastName);
          this.ngForm.controls.email.setValue(res.email);
          this.emailForm.controls.email.setValue(res.email);
          this.ngForm.controls.mobilePhone.setValue(res.mobilePhone);
          this.ngForm.controls.addressLine1.setValue(res.addressLine1);
          this.ngForm.controls.addressLine2.setValue(res.addressLine2);
          this.ngForm.controls.city.setValue(res.city);
          this.ngForm.controls.state.setValue(res.state);
          this.ngForm.controls.zip.setValue(res.zip);
          this.ngForm.controls.isAccredited.setValue(res.isAccredited);
          this.status = res.isAccredited;
          this.isAllowAccredited = res.isAccredited ? this.isVerified() : true;
        }
      });
    }
  }

  getInitial() {
    const info = this._currentUser.getUserInfo();
    this.investorInitial = `${info.firstName.charAt(0)}${info.lastName.charAt(
      0
    )}`.toUpperCase();
  }

  updateInfo(status) {
    if (status) {
      return;
    }
    const postObj = {
      FirstName: this.ngForm.value.firstName,
      LastName: this.ngForm.value.lastName,
      Email: this.ngForm.value.email,
      MobilePhone: this.ngForm.value.mobilePhone,
      AddressLine1: this.ngForm.value.addressLine1,
      AddressLine2: this.ngForm.value.addressLine2 || '',
      City: this.ngForm.value.city,
      State: this.ngForm.value.state,
      Zip: this.ngForm.value.zip,
      IsAccredited: this.ngForm.value.isAccredited ? 1 : 0
    };
    this._usersApi.updateInvestorInfo(this.username, postObj).subscribe(res => {
      if (res) {
        const props: ConfirmationProps = {
          status: 'success',
          title: 'Profile Updated!',
          desc: `The changes to your profile have been saved.`,
          buttonLabel: 'Go to Dashboard'
        };
        const modalRef = this.modalService.show(ConfirmationComponent, {
          initialState: { props },
          animated: false,
          class: 'confirmation'
        });
        (<ConfirmationComponent>modalRef.content).onClose.subscribe(result => {
          if (result) {
            this.router.navigate(['/dashboard']);
          }
        });
      }
    });
  }

  verify() {
    const modalRef = this.modalService.show(InvestorVerificationComponent, {
      ignoreBackdropClick: true,
      class: 'modal-lg'
    });
    (<InvestorVerificationComponent>modalRef.content).onClose.subscribe(
      result => {
        if (result) {
          const currentUser = this._currentUser.getUserInfo();
          this.investorNotVerify = currentUser.verificationStatus;
        }
      }
    );
  }

  fillAddressForm(place) {
    this.zipIsEmpty = false;
    this.ngForm.reset();
    if (this.info) {
      this.ngForm.controls['firstName'].setValue(this.info.firstName);
      this.ngForm.controls['lastName'].setValue(this.info.lastName);
      this.ngForm.controls['email'].setValue(this.info.email);
      this.ngForm.controls['mobilePhone'].setValue(this.info.mobilePhone);
      this.ngForm.controls['isAccredited'].setValue(this.info.isAccredited);
    }
    const placeComponents = place.address_components;
    this.ngForm.controls['state'].setValue(
      this.getLongName(
        placeComponents,
        GOOGLE_ADDRESS_COMPONENT_EQUIVALENT.STATE
      )
    );
    this.zipIsEmpty = !this.getLongName(
      placeComponents,
      GOOGLE_ADDRESS_COMPONENT_EQUIVALENT.ZIP
    );
    this.ngForm.controls['zip'].setValue(
      this.getLongName(placeComponents, GOOGLE_ADDRESS_COMPONENT_EQUIVALENT.ZIP)
    );

    this.ngForm.controls['city'].setValue(
      this.getLongName(
        placeComponents,
        GOOGLE_ADDRESS_COMPONENT_EQUIVALENT.CITY
      )
    );
    if (place.name !== undefined) {
      this.ngForm.controls['addressLine1'].setValue(place.name);
    }

    if (
      place.vicinity !== undefined &&
      !this.checkVicinityExist(place.vicinity)
    ) {
      this.ngForm.controls['addressLine2'].setValue(place.vicinity);
    }
  }

  changeZip(value) {
    this.zipIsEmpty = !value;
  }

  getLongName(placeComponents, fieldType) {
    this.fieldFilleds = [];
    let componentExist: { [key: string]: any } = {};
    componentExist = placeComponents.find(component => {
      const componentTypes = component.types || [];
      const typeExist = componentTypes.filter(type => type === fieldType);
      return typeExist.length > 0;
    });
    if (
      componentExist !== undefined &&
      Object.keys(componentExist).length > 0
    ) {
      this.fieldFilleds.push(componentExist);
    }
    return (
      (componentExist !== undefined &&
        componentExist.hasOwnProperty('long_name') &&
        componentExist.long_name) ||
      ''
    );
  }

  checkVicinityExist(vicinity) {
    const doesExist = this.fieldFilleds.filter(keyword => {
      return (
        (keyword !== undefined &&
          (keyword.hasOwnProperty('long_name') &&
            keyword.long_name === vicinity)) ||
        (keyword.hasOwnProperty('short_name') &&
          keyword.short_name === vicinity)
      );
    });

    return doesExist.length > 0;
  }

  accreditedStatusChange() {
    this.status = this.controls.isAccredited.value;
    this.isAllowAccredited = this.controls.isAccredited.value
      ? this.isVerified()
      : true;
  }

  // Upload Photo
  getFiles(value: FileList) {
    this.isLoading = true;
    const file = value.item(0);
    if (file) {
      const fileSize = file.size * 0.001;
      const type = file.name.split('.').pop();
      if (PHOTO_TYPES.includes(type)) {
        if (fileSize < 1100) {
          this._usersApi
            .uploadInvestorPhoto(this.username, file)
            .subscribe(() => {
              this.getPhoto(this.username);
              this.myTimeOut = setTimeout(() => {
                this._currentUser.loanUserInfo().then(() => {
                  this._headerService.updateAvatar(true);
                });
                this._headerService.updateAvatar(false);
              }, 1500);
            });
        } else {
          this.isLoading = false;
          this._notification.create('warning', `Maximum image size is 1MB!`, {
            Position: 'top-right',
            Style: 'flip',
            Duration: 2000
          });
        }
      } else {
        this.isLoading = false;
        this._notification.create('warning', `Invalid image type!`, {
          Position: 'top-right',
          Style: 'flip',
          Duration: 2000
        });
      }
    }
    this.files = null;
  }

  showAccreditedInfo() {
    const modalRef = this.modalService.show(AccreditedInvestorsComponent, {
      ignoreBackdropClick: false,
      class: 'modal-lg'
    });
  }

  updateSecurityInfo(status) {
    if (status) {
      return;
    }
    const postData = {
      oldPassword: this.securityControls.currentPassword.value,
      newPassword: this.securityControls.password.value
    };
    this._profile.changePassword(this.username, postData).subscribe(res => {
      if (res) {
        this.securityForm.reset();
        const props: ConfirmationProps = {
          status: 'success',
          title: 'Security Updated!',
          desc: `The changes to your password have been saved.`,
          buttonLabel: 'Go to Dashboard'
        };
        const modalRef = this.modalService.show(ConfirmationComponent, {
          initialState: { props },
          animated: false,
          class: 'confirmation'
        });
        (<ConfirmationComponent>modalRef.content).onClose.subscribe(result => {
          if (result) {
            this.router.navigate(['/dashboard']);
          }
        });
      }
    });
  }

  checkCurrentPassword() {
    const password = { password: this.securityControls.currentPassword.value };
    if (
      !!password.password &&
      this.securityControls.currentPassword.status === 'VALID'
    ) {
      this._profile.checkPassword(this.username, password).subscribe(res => {
        this.isValidCurrentPassword = res || false;
      });
    }
  }

  closeEmailWarning() {
    this.isEmailChange = false;
    this.isEmailSubmit = false;
    this._auth.logout();
    this._currentUser.clearInfo();
    this.router.navigate(['/login']);
    this.modalRef.hide();
  }

  updateEmail(status) {
    if (
      status ||
      this.emailExist ||
      this.isEmailSubmit ||
      !this.isEmailChange
    ) {
      return;
    }
    this.isEmailSubmit = true;
    const postData = {
      NewEmail: this.emailForm.controls.email.value
    };
    this._profile.changeEmail(this.username, postData).subscribe(res => {
      if (res) {
        this.modalRef = this.modalService.show(this.emailWarning, {
          animated: false,
          keyboard: false,
          ignoreBackdropClick: true,
          class: 'confirmation'
        });
      }
    });
  }

  checkNewEmail() {
    if (this.emailTimeout) {
      clearTimeout(this.emailTimeout);
    }

    this.emailTimeout = setTimeout(() => {
      this.checkEmail();
    }, 1000);
  }

  checkEmail(submit: boolean = false) {
    const email = { NewEmail: this.emailControls.email.value };
    if (!!email.NewEmail && this.emailControls.email.status === 'VALID') {
      this._profile.checkEmail(this.username, email).subscribe(res => {
        if (res && res.status) {
          this.emailExist = (res && res.status === 1) || false;
          this.isEmailChange = (res && res.status === 3) || false;
          if (!this.emailExist && submit) {
            this.updateEmail(false);
          }
        }
      });
    }
  }

  isNewPasswordInvalid() {
    return (
      this.securityControls.currentPassword.value &&
      this.securityControls.currentPassword.value ===
        this.securityControls.password.value
    );
  }

  get controls() {
    return this.ngForm.controls;
  }

  get securityControls() {
    return this.securityForm.controls;
  }

  get emailControls() {
    return this.emailForm.controls;
  }
}
